<template>
    <brick-settings-popup
        :resources="{
            deletePromptTitle: resource('JourneyBuilder_BrickSettingsAudienceFilter_Delete_Title'),
            deletePromptBody: resource('JourneyBuilder_BrickSettingsAudienceFilter_Delete_Body'),
            brickTitle: `${resource('JourneyComposer_BrickSettingsAudienceFilter_Title')} ${resource('JourneyComposer_BrickSettingsBase_Title')}`
        }"
        :brick="brick"
        :name.sync="newName"

        @save="saveSettings()"
        @delete="$emit('delete')"
        @hidden="$emit('hidden')"
    >
        <span class="conditions-header">{{resource('JourneyComposer_BrickSettingsAudienceFilter_Conditions_DisplayName')}}</span>

        <id-dispenser :elements="settings.conditions">
            <template v-slot="{ idsPerElement }">
                <template v-for="(condition, index) in settings.conditions">
                    <div :key="idsPerElement.get(condition)">
                        <div class="row">
                            <div class="col-12">
                                <audience-filter-brick-condition
                                    class="filter-condition"

                                    :name.sync="condition.name"
                                    :color.sync="condition.color"
                                    :fields.sync="condition.fields"

                                    @delete="deleteConditionAt(index)"
                                />
                            </div>
                        </div>
                    </div>
                </template>
            </template>
        </id-dispenser>

        <div class="row mt-2">
            <div class="col-8"></div>
            <div class="col-4">
                <button class="btn btn-outline-secondary btn-icon-left w-100" @click="addNewCondition" :disabled="!canWrite">
                    <i class="fa fa-plus"></i> {{resource('JourneyComposer_BrickSettingsAudienceFilter_AddCondition_DisplayName')}}
                </button>
            </div>
        </div>

    </brick-settings-popup>
</template>

<script>
    import snowplow from '@modules/JourneyBuilder/snowplow';
    import {sizes} from '@core/Components/Util/Modal.vue';

    import resources from '@core/Util/Mixins/resources';
    import brickSettingsMixin from '../Mixins/brick-settings'
    import permissionsMixin from '@modules/JourneyBuilder/Mixins/journey-permissions';

    import IdDispenser from "@core/Components/Util/IdDispenser.vue";
    import InputGroup from '@core/Components/Inputs/InputGroup.vue';
    import BrickSettingsPopup from "../BrickSettingsPopup";
    
    import AudienceFilterBrickCondition from './AudienceFilterBrickCondition.vue';
    
    export default {
        name: 'brick-settings-audience-filter',
        mixins: [permissionsMixin, brickSettingsMixin, resources],
        components: {
            BrickSettingsPopup,
            InputGroup,
            AudienceFilterBrickCondition,
            IdDispenser
        },
        created() {
            const vm = this;
            
            //Ensure a conditions property 
            // * is present
            // * is reactive
            // * is deep cloned, and does not modify the original object
            if(vm.settings.conditions){
                vm.settings.conditions = vm.settings.conditions.map(c => {
                    //Take connection existing properties + any potential new properties
                    return Object.assign(vm.createBaseCondition(), c);
                });
            }
            else {
                vm.$set(vm.settings, 'conditions', []);   
            }
        },
        computed: {
            modalSize() {
                return sizes.large;
            }
        },
        methods: {
            createBaseCondition: () => ({
                name: null,
                color: '',
                fields: []
            }),
            addNewCondition(){
                //Creating a new array is sure to trigger Vue's reactivity
                this.settings.conditions.push(this.createBaseCondition());
            },
            deleteConditionAt(index){
                this.settings.conditions.splice(index, 1);
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import "~@modules/JourneyBuilder/Style/audience-filter-brick.scss";
</style>
